<template>
  <div
    style="height: 100vh;"
  >
    <div
      style="
        height: 100vh;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        overflow: hidden;
      "
    >
      <img
        v-for="(image, idx) in value"
        :key="image.url"
        style="width: 100%; height: 100%; object-fit: cover"
        v-lazy-image
        :data-src="image.url"
        :class="getImgCls(idx)"
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "SlideShow",
  props: {
    value: {
      type: Array[Object],
      default: [],
    },
  },
  data() {
    return {
      index: 0,
      counterFn: null,
    };
  },
  methods: {
    getImgCls(idx) {
      if (idx === this.index) {
        return "img-fluid elementToFadeOut";
      } else if (idx === this.index + 1 || this.index === this.value.length) {
        return "img-fluid elementToFadeIn";
      } else {
        return "img-fluid hidden";
      }
    },
    refreshIndex() {
      this.index = (this.index + 1) % this.value.length;
      this.counterFn = setTimeout(this.refreshIndex, 8000);
    },
  },
  mounted() {
    this.counterFn = setTimeout(this.refreshIndex, 8000);
  },
  destroyed() {
    clearTimeout(this.counterFn);
  },
};
</script>

<style scoped>
.hidden {
  display: none;
}

.elementToFadeOut {
  display: "";
  position: absolute;
  transition: transform 330ms ease-in-out;
  -webkit-animation: fadeout 9s;
  animation: fadeout 9s;
  opacity: 0;
}

@-webkit-keyframes fadeout {
  0% {
    opacity: 1;
    transform: scale(1.05);
  }
  20% {
    opacity: 1;
  }
  40% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  80% {
    opacity: 0.3;
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}

@keyframes fadeout {
  0% {
    opacity: 1;
    transform: scale(1.05);
  }
  20% {
    opacity: 1;
  }
  40% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  80% {
    opacity: 0.3;
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}

.elementToFadeIn {
  display: "";
  position: absolute;
  -webkit-animation: fadein 9s;
  animation: fadein 9s;
  opacity: 1;
}

@-webkit-keyframes fadein {
  0% {
    opacity: 0;
    transform: scale(1);
  }
  20% {
    opacity: 0;
  }
  40% {
    opacity: 0;
  }
  60% {
    opacity: 0;
  }
  80% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
    transform: scale(1.05);
  }
}

@keyframes fadein {
  0% {
    opacity: 0;
    transform: scale(1);
  }
  20% {
    opacity: 0;
  }
  40% {
    opacity: 0;
  }
  60% {
    opacity: 0;
  }
  80% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
    transform: scale(1.05);
  }
}
</style>